// extracted by mini-css-extract-plugin
export default {"about_container":"about_about_container__l0tyt","background_color":"about_background_color__BGoE6"};